module.exports = __webpack_public_path__ + "img/icon-phone.441fb08.svg";